import React from "react"

import {FieldGraphTickLabelViewProps} from "../../../render/graph-tick-label"
import PriorityIcon from "../../../../gd-components/priority/priority-icon/priority-icon"
import Field_GraphTickLabelView from "../../../proto/render/graph-tick-label"

const LABEL_SHOW_THRESHOLD = 100

const debug = false
// const debug = "FieldPriority_GraphTickLabelView"

export default function FieldPriority_GraphTickLabelView(props: FieldGraphTickLabelViewProps) {

    const value = props.field.getViewValue(props.model)
    let option = props.field._getOption(value)
    if (!option) { // if no value then set special field value
        option = {
            value   : parseInt(value),
            label   : props.field.noValueOptionLabel
        }
    }

    debug && console.log(debug, 'render', option, props)

    let showLabel = props.params.availableWidth > LABEL_SHOW_THRESHOLD

    const iconClasses = Classes({
        'm-r-5': showLabel
    })

    return (
        <Field_GraphTickLabelView {...props} hintName={option.label}>
            <PriorityIcon className={iconClasses} priority={option.value}/>
            {showLabel && <div className="ui5-txt-default-small txt-truncate">{option.label}</div>}
        </Field_GraphTickLabelView>
    )
}